export default "__VITE_ASSET__DTP$IyBU__"